import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ArticleContainer = styled.article``;

/**
 *  Primary function  - Used as a semantic wrapper for Blog posts
 */
const Article = ({ children }) => (
  <ArticleContainer>{children}</ArticleContainer>
);

Article.propTypes = {
  children: PropTypes.node.isRequired
};

export { Article };
